import { Backdrop, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppState } from '../store/AppStore';
/**
 * An overlay with a loading circle which is displayed if there is some background task running
 * @returns {JSX.Element} the overlay with the loading circle component
 */
export const LoadingScreen = () => {
  const { t } = useTranslation();

  //selectors
  const busy = useSelector((state: AppState) => state.busy);

  return (
    <Backdrop open={busy}>
      <>
        <CircularProgress /> &nbsp; {t('message.loading')}
      </>
    </Backdrop>
  );
};
